import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SubsectionInFrame = ({
  className,
  title,
  onTitleClick,
  color,
  layout,
  twoRows,
  actionable,
  headerStyle,
  center,
  topPadding,
  gap,
  lastInRow,
  noSidePadding,
  noBottomPadding,
  children,
}) => {
  return (
    <div className="subsection-wrapper">
      <section
        className={classNames('subsection-frame', {
          'subsection-light': color === 'light',
          'subsection-medium': color === 'medium',
          [className]: Boolean(className),
          'subsection-last-in-row': lastInRow,
        })}
      >
        {title && (
          <div
            className={classNames('subsection-frame-header', {
              'subsection-frame-header_with-price': twoRows,
              'subsection-frame-header_narrow': headerStyle === 'narrow',
              'subsection-frame-header_warning': color == 'warning',
              'subsection-frame-header_main': color == 'main',
            })}
            onClick={() => onTitleClick && onTitleClick()}
          >
            {title}
          </div>
        )}
        <div
          className={classNames('subsection-frame-body', {
            [`${className}-body`]: Boolean(className),
            'subsection-column': layout === 'column',
            'subsection-actionable': actionable,
            'subsection-center': center,
            'subsection_with-top-padding': topPadding,
            'subsection_with-no-bottom-padding': noBottomPadding,
            'subsection_with-no-side-padding': noSidePadding,
          })}
          style={{ gap: `${gap}px` }}
        >
          {children}
        </div>
      </section>
    </div>
  );
};

SubsectionInFrame.defaultProps = {
  color: 'dark',
  layout: 'row',
  twoRows: false,
  actionable: false,
  headerStyle: 'wide',
  center: false,
  topPadding: false,
  gap: 0,
};

SubsectionInFrame.propTypes = {
  className: PropTypes.string,
  title: PropTypes.object,
  onTitleClick: PropTypes.func,
  color: PropTypes.oneOf(['main', 'light', 'dark', 'medium', 'warning']),
  layout: PropTypes.oneOf(['column', 'row']),
  twoRows: PropTypes.bool,
  actionable: PropTypes.bool,
  headerStyle: PropTypes.oneOf(['narrow', 'wide']),
  center: PropTypes.bool,
  topPadding: PropTypes.bool,
  gap: PropTypes.number,
  lastInRow: PropTypes.bool,
  noSidePadding: PropTypes.bool,
  noBottomPadding: PropTypes.bool,
  children: PropTypes.node,
};

export { SubsectionInFrame };

export default SubsectionInFrame;
